







































































































import { Component, Vue, Watch } from "vue-property-decorator";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import { IAction } from "../common/CommonTypes";
import { PostsApi } from "../../../apis";
import { format, parseISO } from "date-fns";
import ConfirmDialog from "../user-management/ConfirmDialog.vue";

export enum ACTION {
  VIEW = "VIEW",
  EDIT = "EDIT",
  DELETE = "DELETE",
}

@Component({
  components: {
    MoreVertBtn,
    ConfirmDialog,
  },
})
export default class Instruction extends Vue {
  fromDateSearch = "";
  toDateSearch = "";
  keyword = "";
  isEn = true;
  isVn = false;
  isECO2 = true;
  showConfirmDialog = false;
  errDialog = "";
  confirmContent = "";

  selectedPermisstionId = "";
  selectedPermisstion = {} as any;
  selectedAction: ACTION;
  imageUrl = "https://www.industrialempathy.com/img/remote/ZiClJf-1920w.jpg";
  get ACTIONS(): IAction[] {
    return [
      {
        titleName: this.$t("text.view"),
        titleStyle: "color: black; font-weight: 600",
        action: ACTION.VIEW,
      },
      {
        titleName: this.$t("text.edit"),
        titleStyle: "color: black; font-weight: 600",
        action: ACTION.EDIT,
      },
      {
        titleName: this.$t("text.delete"),
        action: ACTION.DELETE,
        titleStyle: "color: red; font-weight: 600",
      },
    ];
  }

  data = [];
  checkStatusAction() {
    return this.ACTIONS.filter((val) => val.action);
  }
  navigateDetail() {
    const id = this.selectedPermisstion.id;
    this.$router.push({ name: "instruction-detail", params: { id } });
  }
  navigateDetailMore(id: string) {
    this.$router.push({ name: "instruction-detail", params: { id } });
  }
  navigateEdit() {
    const id = this.selectedPermisstion.id;
    this.$router.push({ name: "edit-instruction", params: { id } });
  }

  async delete() {
    const id = this.selectedPermisstion.id;
    this.$util.showLoading();
    try {
      const rs = await new PostsApi().deletePost({
        id: id,
      });
    } catch (error) {
    } finally {
      this.$util.hideLoading();
      this.doSearch();
    }
  }

  onCancelDialog() {
    this.errDialog = "";
  }

  onOkConfirmDialog() {
    if (this.selectedAction === ACTION.DELETE) {
      this.delete();
    }
  }

  onDeleteInstruction() {
    this.showConfirmDialog = true;
    this.confirmContent = `${this.$t(
      "dialog.confirmInstruction.contentDelete"
    )}`;
  }

  async beforeMount() {
    return await this.doSearch();
  }

  onSelectedPermission(item, action): void {
    this.selectedPermisstion = { ...item };
    this.selectedAction = action;
    switch (action) {
      case ACTION.VIEW: {
        this.navigateDetail();
        break;
      }
      case ACTION.EDIT: {
        this.navigateEdit();
        break;
      }
      case ACTION.DELETE: {
        this.onDeleteInstruction();
        break;
      }
      default: {
        break;
      }
    }
  }
  get currentLocale() {
    return this.$store.getters.locale;
  }

  @Watch("currentLocale")
  onCurrentLocaleWatch() {
    this.doSearch();
  }

  async doSearch() {
    if (this.$store.getters.user.organization === "CLIENT") {
      this.isECO2 = false;
    }
    if (this.$store.getters.locale === "vi") {
      this.isEn = false;
      this.isVn = true;
    } else {
      this.isVn = false;
      this.isEn = true;
    }
    this.$util.showLoading();
    try {
      const rs = await new PostsApi().getPostsByKeywordAndLanguageAndFromTo({
        keyword: this.keyword,
        from: this.fromDateSearch,
        to: this.toDateSearch,
      });
      this.data = rs.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
}
